import { Form, Space, Switch, Typography } from 'antd';
import styled from 'styled-components';
import {
  UserAccountNotificationSettingsResponse,
  UserAccountProfileResponse,
  useGetMyAccount,
  useUpdateMyAccount,
} from '@/shared/api';
import { Col, Row } from '@/shared/ui';
import { captureError } from '@/shared/utils/error-reporting';

const { Title, Text } = Typography;

export const Notifications = () => {
  const { data } = useGetMyAccount<{
    profile: UserAccountProfileResponse;
    notificationSettings: UserAccountNotificationSettingsResponse;
  }>({});

  const { mutate: updateAccount } = useUpdateMyAccount();

  const onChange = ({
    field,
    checked,
  }: {
    field: string;
    checked: boolean;
  }) => {
    const fields = field.split('.');
    try {
      updateAccount({
        body: {
          notificationSettings: {
            [fields[0]]: {
              [fields[1]]: checked,
            },
          },
        },
      });
    } catch (error) {
      captureError(error, {
        module: 'notifications_on_error_update_account',
        action: 'update_account',
      });
    }
  };

  return (
    <div>
      <Title level={3} style={{ marginBottom: 5 }}>
        Notifications
      </Title>
      <Subheading>Manage when you'll receive notifications.</Subheading>
      <Form
        name="notifications"
        initialValues={data?.notificationSettings}
        style={{ marginTop: 30, maxWidth: 450 }}
      >
        <Space direction="vertical" size="large">
          <Title level={5} style={{ marginBottom: 0 }}>
            In-app notifications
          </Title>
          <Row gap={20}>
            <Form.Item
              name={['inAppSettings', 'newComments']}
              valuePropName="checked"
            >
              <Switch
                onChange={(checked) =>
                  onChange({ field: 'inAppSettings.newComments', checked })
                }
              />
            </Form.Item>
            <Col alignItems="flex-start">
              <div>New comment</div>
              <Description>There is a new comment on my proc.</Description>
            </Col>
          </Row>
          {/* <Row gap={20}>
            <Form.Item  valuePropName="checked">
              <Switch />
            </Form.Item>
            <Col alignItems="flex-start">
              <div>Proc completed</div>
              <Description>Someone completed instance of my proc.</Description>
            </Col>
          </Row> */}
          <Col alignItems="flex-start">
            <Title level={5}>Email notifications</Title>
            <Subheading>
              Will take place when you are not logged into the app.
            </Subheading>
          </Col>
          <Row gap={20}>
            <Form.Item
              name={['emailSettings', 'newComments']}
              valuePropName="checked"
            >
              <Switch
                onChange={(checked) =>
                  onChange({ field: 'emailSettings.newComments', checked })
                }
              />
            </Form.Item>
            <Col alignItems="flex-start">
              <div>New comment</div>
              <Description>There is a new comment on my proc.</Description>
            </Col>
          </Row>
          <Row gap={20}>
            <Form.Item
              name={['emailSettings', 'newCompletedProcs']}
              valuePropName="checked"
            >
              <Switch
                onChange={(checked) =>
                  onChange({
                    field: 'emailSettings.newCompletedProcs',
                    checked,
                  })
                }
              />
            </Form.Item>
            <Col alignItems="flex-start">
              <div>Proc completed</div>
              <Description>Someone completed instance of my proc.</Description>
            </Col>
          </Row>
        </Space>
      </Form>
    </div>
  );
};

const Subheading = styled(Text)`
  opacity: 0.8;
`;

const Description = styled(Text)`
  opacity: 0.6;
`;
